module.exports = {"name":"dao","comment":"DAO rescue hardfork","eip":{"url":"https://eips.ethereum.org/EIPS/eip-779","status":"Final"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethereumjs-common/dist/hardforks/dao.json
// module id = xpxx
// module chunks = 5